import { Component, OnInit, Input} from '@angular/core';
import { FormGroup } from '@angular/forms';
import{LoopBackAuth, listadosService, matriculaService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';

@Component({
  selector: 'form-porcentaje-beca',
  templateUrl: './form-porcentaje-beca.component.html',
  providers:[LoopBackAuth, listadosService, matriculaService, MessageService]
})
export class FormPorcentajeBecaComponent implements OnInit {
  @Input() formBeca: FormGroup
  @Input() hiddenBecas: boolean = true
  becas: any

  constructor(
    private listadosService: listadosService,
  ) { }

  ngOnInit() {
      this.listadosService.descuentosActivos().subscribe(
        lista => {
          this.becas = lista
          
          if(this.hiddenBecas){
            this.formBeca.get('beca').disable()
          }else{
            this.formBeca.get('beca').enable()
          }
        }
      )
  }

  

}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/form-porcentaje-beca.component.ts